
import store from './config/store'
import routesWidgetErgebnisliste from './config/routesWidgetErgebnisliste'
import routesWidgetAccount from './config/routesWidgetAccount'

import "@/assets/scss-website-widgets/website-widgets.scss"

import { createWidgets } from './utils/vueUtils'
import WidgetErgebnisliste from '@/top-level/WidgetErgebnisliste.vue'
import WidgetBeratungsSuche from "@/top-level/WidgetBeratungsSuche.vue";
import WidgetHomeKarte from "@/top-level/WidgetHomeKarte.vue";
import WidgetAccount from "@/top-level/WidgetAccount.vue";

createWidgets([
  {
    name: 'ergebnisliste',
    widget: WidgetErgebnisliste,
    store: store,
    routes: routesWidgetErgebnisliste,
    i18n: true,
    debounce: true
  },
  {
    name: 'beratungssuche',
    widget: WidgetBeratungsSuche,
    store: store,
    i18n: true,
    debounce: true
  },
  {
    name: 'karte',
    widget: WidgetHomeKarte,
    store: store,
    i18n: true
  },
  {
    name: 'account',
    widget: WidgetAccount,
    store: store,
    i18n: true,
    routes: routesWidgetAccount,
    debounce: true
  }
])
